<script lang="ts">
    interface Props {
        group?: any
        value?: any
        label: any
        checked?: boolean
        required?: boolean
        children?: import("svelte").Snippet
    }

    let {
        group = $bindable([]),
        value = undefined,
        label,
        checked = $bindable(false),
        required = false,
        children,
    }: Props = $props()

    let id = "_" + Math.random().toString(36).substr(2, 9)
</script>

<div class="inputholder">
    <input type="checkbox" {value} bind:group {id} bind:checked {required} />
    <label for={id}
        ><span
            >{label}
            {@render children?.()}</span
        ></label
    >
</div>

<style lang="less">
    .inputholder {
        position: relative;
        margin-bottom: 15px;
        input[type="checkbox"] {
            width: auto;
            opacity: 0.00000001;
            position: absolute;
            left: 0;
            margin-left: -20px;
        }
        label {
            position: relative;
            min-height: 25px;
            display: block;
            padding-left: 40px;
            margin-bottom: 0;
            font-weight: normal;
            cursor: pointer;
            display: flex;
            display: -webkit-flex;
            align-items: center;
            font-size: 1rem;
            line-height: 1;
            text-transform: none;
            color: var(--comp--section-type-1--color);

            &:before {
                content: "";
                position: absolute;
                left: 0;
                top: 0px;
                width: 25px;
                height: 25px;
                transition: transform 0.28s ease;
                border-radius: 3px;
                background: transparent;
                border: 1px solid var(--border-color-default);
            }
            &:after {
                content: "";
                display: block;
                width: 11px;
                height: 4px;
                transform: rotate(-45deg) scale(0);
                transition: transform ease 0.25s;
                position: absolute;
                top: 8px;
                left: 7px;
            }
        }
        input[type="checkbox"]:checked ~ label:after {
            transform: rotate(-45deg) scale(1);
        }
        input[type="checkbox"]:checked ~ label:before {
            background: rgb(97, 238, 3);
        }
    }
</style>
